<template>

<div class="scores-container">
    <div class="risk-score-card">
        <i class="fa fa-book risk-icon">  Financial Diary</i> </div>
    <div class="financial-diary">
      <div v-for="(entry, index) in diaryEntries" :key="index" class="diary-entry">
        <h3>{{ entry.prompt }}</h3>
        <p v-if="entry.content">{{ entry.content }}</p>
        <button v-if="entry.content" @click="prepareEditEntry(entry)">Edit Response</button>
        <button v-else @click="prepareEditEntry(entry)">Respond</button>
      </div>
  
      <!-- Form for Editing Diary Entries -->
      <div v-if="showAddDiaryForm" class="diary-form">
        <h3>Responding to: "{{ formEntry.prompt }}"</h3>
               <!-- Dropdown for Financial Mood -->
               <select v-model="formEntry.financial_mood">
          <option value="">Select Financial Mood</option>
          <option value="😓 Stressed">😓 Stressed</option>
          <option value='😢 Sad'>😢 Sad</option>
          <option value='😩 Overwhelmed'>😩 Overwhelmed</option>
          <option value='😌 Content'>😌 Content</option>
          <option value='😃 Happy'>😃 Happy</option>
        </select>
        <textarea v-model="formEntry.content" placeholder="Your thoughts..."></textarea>
 
  
      <button @click="submitEditEntry">Save Response</button>
      <button @click="showAddDiaryForm = false">Cancel</button>
      </div>
  
    
</div>
    </div><br>
  </template>

<script>
import { ref, onMounted } from 'vue';
import axios from 'axios';
import { Auth } from 'aws-amplify';

export default {
  setup() {
    const diaryEntries = ref([]);
    const formEntry = ref({
      title: '',
      content: '',
      financial_mood: '',
      job_satisfaction: '',
      note: '',
      prompt: ''
    });
    const showAddDiaryForm = ref(false);
    const isEditing = ref(false);

    const fetchDiaryEntries = async () => {
      try {
        const user = await Auth.currentAuthenticatedUser();
        const cognitoSub = user.attributes.sub;
        const response = await axios.get('https://api.riskypaws.com/frontoffice/api/financial-diary/', {
          headers: { 'X-Cognito-Sub': cognitoSub }
        });
        diaryEntries.value = response.data;
      } catch (error) {
        console.error('Error fetching diary entries:', error);
      }
    };

    const addNewEntry = async () => {
  try {
    const user = await Auth.currentAuthenticatedUser();
    const cognitoSub = user.attributes.sub;
    const response = await axios.post('https://api.riskypaws.com/frontoffice/api/financial-diary/', formEntry.value, {
      headers: { 'X-Cognito-Sub': cognitoSub }
    });
    showAddDiaryForm.value = false;
    diaryEntries.value.push(response.data);
  } catch (error) {
    console.error('Error adding diary entry:', error);
  }
};

    const submitEditEntry = async () => {
      try {
        const user = await Auth.currentAuthenticatedUser();
        const cognitoSub = user.attributes.sub;
        await axios.put(`https://api.riskypaws.com/frontoffice/api/financial-diary/${formEntry.value.id}/`, formEntry.value, {
          headers: { 'X-Cognito-Sub': cognitoSub }
        });
        showAddDiaryForm.value = false;
        isEditing.value = false;
        fetchDiaryEntries();
      } catch (error) {
        console.error('Error editing diary entry:', error);
      }
    };

    const deleteEntry = async (entryId) => {
      try {
        const user = await Auth.currentAuthenticatedUser();
        const cognitoSub = user.attributes.sub;
        await axios.delete(`https://api.riskypaws.com/frontoffice/api/financial-diary/${entryId}/`, {
          headers: { 'X-Cognito-Sub': cognitoSub }
        });
        fetchDiaryEntries();
      } catch (error) {
        console.error('Error deleting diary entry:', error);
      }
    };

    const prepareEditEntry = (entry) => {
      formEntry.value = { ...entry };
      isEditing.value = true;
      showAddDiaryForm.value = true;
    };

    onMounted(() => {
      fetchDiaryEntries();
    });

    return {
      diaryEntries,
      formEntry,
      showAddDiaryForm,
      isEditing,
      addNewEntry,
      submitEditEntry,
      deleteEntry,
      prepareEditEntry
    };
  }
};
</script>
<style scoped>

.risk-score-card {
  display: flex;
  align-items: center;
  width: 100%;
  padding: 20px;
  margin-bottom: 20px;
  background-color: #36454f;
  color: white;
  font-size: 24px;
  border-radius: 10px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  }

  .scores-container {
    display: flex;
    flex-wrap: wrap; /* Allows items to move to the next row on smaller screens */
    justify-content: center; /* Centers items */
    align-items: center;
    width: 100%;
    border: 2px solid #000;
    border-radius: 10px;
    padding: 20px;
    box-sizing: border-box;
    background-color: white; 
  }
.financial-diary {
  font-family: 'Times New Roman', Times, serif; /* Classic diary-like font */
  max-width: 600px;
  margin: auto;
  padding: 20px;
  background: #f9f9f9; /* Soft background color */
  border: 1px solid #ddd; /* Subtle border */
  border-radius: 5px;
}

.diary-entry {
  border-bottom: 1px solid #ddd; /* Separator between entries */
  padding: 15px;
}

.diary-entry h3 {
  color: #333;
  font-weight: bold;
}

.diary-entry p {
  color: #555;
  margin-bottom: 10px;
}

.diary-form {
  background: white;
  padding: 20px;
  border: 2px solid #ccc;
  border-radius: 10px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  margin-top: 20px;
}

.diary-form h3 {
  margin-bottom: 15px;
  color: #444;
}

.diary-form input[type="text"], .diary-form textarea, .diary-form select {
  width: 100%;
  padding: 8px;
  margin-bottom: 10px;
  border: 1px solid #ccc;
  border-radius: 4px;
  box-sizing: border-box;
}

.diary-form textarea {
  height: 100px;
}

.diary-form button {
  background-image: linear-gradient(135deg, #6D5BBA 0%, #8D58BF 100%); /* Apply the same gradient as your app theme */
  color: white;
  border: none;
  padding: 10px 15px;
  border-radius: 5px;
  margin: 5px;
  cursor: pointer;
  transition: background-color 0.3s, box-shadow 0.3s;
}

.diary-form button:hover {
  background-image: linear-gradient(135deg, #8D58BF 0%, #6D5BBA 100%); /* Slightly adjust gradient for hover effect */
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2); /* Add a shadow for depth */
}

button {
  background-image: linear-gradient(135deg, #6D5BBA 0%, #8D58BF 100%); /* Apply the same gradient as your app theme */
  color: white;
  border: none;
  padding: 10px 15px;
  border-radius: 5px;
  margin: 5px;
  cursor: pointer;
  transition: background-color 0.3s, box-shadow 0.3s;
}
.button:hover {
  background-image: linear-gradient(135deg, #8D58BF 0%, #6D5BBA 100%); /* Slightly adjust gradient for hover effect */
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2); /* Add a shadow for depth */
}
@media screen and (max-width: 600px) {
  .risk-score-card, .toolbar button, .event-form label, .event-form input, .event-form select, .event-form button {
    font-size: 14px; /* Adjust font size for better readability on mobile */
  }

  .button, .toolbar button {
    padding: 8px 10px; /* Adjust button padding for easier clickability */
    margin: 4px; /* Reduce margin to fit more content */
  }

  .event-form {
    grid-template-columns: 1fr; /* Adjust form layout to single column for narrow screens */
  }

  input[type="date"], input[type="text"], input[type="number"], select {
    margin: 4px 0; /* Reduce margin around inputs for compact layout */
  }

  .event-form button {
    padding: 8px 10px; /* Adjust button size for mobile */
  }

  table, th, td {
    font-size: 12px; /* Smaller table font size for mobile */
  }
}
</style>
